import { BASE_URL } from "../../constants";
import {
    addClassesReduc,
    allConversationReduc,
    classDataReduc,
    conversationByIdReduc,
    deleteClassesReduc,
    editClassesReduc,
    failure,
    fetchAllData,
    filterReduc,
    filterUserReduc,
    getChoiceReduc,
    getEstimateCostReduc,
    // getEstimateCostReduc,
    modifyResponseReduc,
    profileDataReduc,
    queryResponseReduc,
    UpdateConversationByIdReduc,
    setSessionReady,
} from "../slices/userSlice";
import { api } from "../../utils/api";
import { FailureToast, SuccessToast } from "../../utils/commonunctions";

export const ensureSessionReady = async (dispatch, callback) => {
    let retries = 0;
    const maxRetries = 10;
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    while (retries < maxRetries) {
        const createdBy = sessionStorage.getItem("createdBy");
        const groupId = sessionStorage.getItem("currentGrp");
        const isAdmin = sessionStorage.getItem("IsAdmin");

        if (createdBy && groupId && isAdmin !== null) {
            return callback();
        }

        retries++;
        await wait(300);
        if (retries === 3) dispatch(userDetailsApi());
    }
};

// Fetch a conversation by ID, including loading state and dispatching data to store
export function conversationByIdAPI(id, isHistory, setIsLoading) {
    const groupID = sessionStorage.getItem("currentGrp");
    return async (dispatch) => {
        await dispatch(conversationByIdReduc({ conversationLoading: true }));
        setIsLoading(true);
        await api
            .get(`${BASE_URL}/conversations/${id}/?group_id=${groupID}`)
            .then((res) => {
                if (res.status === 200) {
                    setIsLoading(false);
                    dispatch(
                        conversationByIdReduc({
                            optionsData: res?.data?.queries?.[0]?.options,
                            data: res?.data,
                            conversationLoading: false,
                        })
                    );
                }
            })
            .catch(() => {
                setIsLoading(false);
                dispatch(conversationByIdReduc({ conversationLoading: false }));
            });
    };
}

// Fetch class/category data from server
export function getClassdataApi() {
    return async (dispatch) => {
        await dispatch(classDataReduc({ classDataLoading: true }));
        await api
            .get(`${BASE_URL}/categories/`)
            .then((res) => {
                if (res.status === 200) {
                    dispatch(classDataReduc({ classDataLoading: false, data: res.data }));
                }
            })
            .catch(() => {
                dispatch(classDataReduc({ classDataLoading: false }));
            });
    };
}

// Create a new class/category
export function createClassesApi(data, setShouldFetch, setIsModalOpen, setFormData, initialForm) {
    return async (dispatch) => {
        await dispatch(addClassesReduc({ modalClassesLoading: true }));
        await api
            .post(`${BASE_URL}/categories/`, data)
            .then((res) => {
                if (res.status === 200) {
                    FailureToast(res?.data?.message); // Possibly shows warning or duplication

                } else if (res.status === 201) {
                    SuccessToast("Successfully Added");
                    setShouldFetch(true);
                    setIsModalOpen(false);
                    setFormData(initialForm);
                }
                dispatch(addClassesReduc({ modalClassesLoading: false }));
            })
            .catch((e) => {
                FailureToast(e?.response?.data?.message);
                dispatch(addClassesReduc({ modalClassesLoading: false }));
                setIsModalOpen(false);
            });
    };
}

// Edit an existing class/category
export function editClassesApi(setShouldFetch, setIsModalOpen, setFormData, initialForm, newData, body) {
    return async (dispatch) => {
        await dispatch(editClassesReduc({ modalClassesLoading: true }));
        await api
            .put(`${BASE_URL}/categories/${newData.id}/`, body)
            .then((res) => {
                if (res.status === 200) {
                    SuccessToast("Successfully Edited");
                    setShouldFetch(true);
                    setIsModalOpen(false);
                    setFormData(initialForm);
                }
                dispatch(editClassesReduc({ modalClassesLoading: false }));
            })
            .catch((err) => {
                FailureToast(err?.response?.data?.message);

                dispatch(editClassesReduc({ modalClassesLoading: false }));
                setIsModalOpen(false);
            });
    };
}




// Delete a class/category by ID
export function deleteClassesApi(setOpen, setShouldFetch, deleteId) {
    console.log("id for delte in alertdialog", deleteId);
    // console.log("open for delte in alertdialog", open);
    // console.log("shouldFetch for delte in alertdialog", shouldFetch);

    return async (dispatch) => {
        await dispatch(deleteClassesReduc({ modalClassesLoading: true }));
        await api
            .delete(`${BASE_URL}/categories/${deleteId}/`)
            .then((res) => {
                if (res.status === 200) {
                    setOpen(false);
                    setShouldFetch(true);
                    SuccessToast("Successfully Deleted");
                }
                dispatch(deleteClassesReduc({ modalClassesLoading: false }));
            })
            .catch(() => {
                dispatch(deleteClassesReduc({ modalClassesLoading: false }));
            });
    };
}


// Modify a response using GPT with custom input
export function modifyResponseApi(id, data, setResponse, setIsLoading, formatResponseText) {
    return async (dispatch) => {
        setIsLoading(true);
        await dispatch(modifyResponseReduc({ modifyLoading: true }));
        await api
            .post(`${BASE_URL}/modify_response/${id}/`, data)
            .then((res) => {
                if (res.status === 200) {
                    setResponse(formatResponseText(res?.data?.modified_response));
                }
                setIsLoading(false);
                dispatch(modifyResponseReduc({ modifyLoading: false }));
            })
            .catch((e) => {
                FailureToast(e?.response?.data?.error);
                setIsLoading(false);
                dispatch(modifyResponseReduc({ modifyLoading: false }));
            });
    };
}

// Fetch choice options used in select fields or questions
export function getChoiceApi() {
    return async (dispatch) => {
        await api
            .get(`${BASE_URL}/choices/`)
            .then((res) => {
                dispatch(getChoiceReduc({ getChoices: res.data }));
            })
            .catch(() => { });
    };
}

// Add a new choice item
export function addChoiceApi(setEditModal, payload, setCategoryValue) {
    return async (dispatch) => {
        await api
            .post(`${BASE_URL}/choices/`, payload)
            .then((res) => {
                if (res.status === 201 || res.status === 200) {
                    dispatch(getChoiceApi());
                    SuccessToast("Choice Added Successfully");
                    setTimeout(() => {
                        setEditModal(false);
                        setCategoryValue("");
                    }, 1200);
                }
            })
            .catch((error) => {
                const errorMessage =
                    error?.response?.data?.error === "Choice not found"
                        ? "Default Choice cannot be update"
                        : error?.response?.data?.value?.[0] ?? "Error occurred while editing";
                FailureToast(errorMessage);
            });
    };
}

// Edit a choice item by ID
export function editChoiceApi(setEditModal, id, dataId, payload, setCategoryValue) {
    return async (dispatch) => {
        await api
            .put(`${BASE_URL}/choices/${id}/${dataId}/`, payload)
            .then((res) => {
                if (res.status === 200) {
                    SuccessToast("Choice Edited Successfully");
                    dispatch(getChoiceApi());
                    setTimeout(() => {
                        setEditModal(false);
                        setCategoryValue("");
                    }, 1200);
                }
            })
            .catch((error) => {
                const errorMessage =
                    error?.response?.data?.error === "Choice not found"
                        ? "Default Choice cannot be update"
                        : error?.response?.data?.value?.[0] ?? "Error occurred while editing";
                FailureToast(errorMessage);

            });
    };
}

// Delete a choice item
export function deleteChoiceApi(setEditModal, id, dataId, setCategoryValue) {
    return async (dispatch) => {
        await api
            .delete(`${BASE_URL}/choices/${id}/${dataId}/`)
            .then((res) => {
                if (res.status === 200) {
                    SuccessToast("Choice Deleted Successfully");
                    dispatch(getChoiceApi());
                    setTimeout(() => {
                        setEditModal(false);
                        setCategoryValue("");
                    }, 1200);
                }
            })
            .catch((error) => {
                const errorMessage =
                    error?.response?.data?.error === "Choice not found"
                        ? "Default Choice cannot be update"
                        : error?.response?.data?.value?.[0] ?? "Error occurred while editing";
                FailureToast(errorMessage);
            });
    };
}

// Submit a new query to the backend, navigate to response page on success
export function submitQueryApi(query, setIsGenerating, navigate, groupID) {
    return async (dispatch) => {
        setIsGenerating(true);
        await api
            .post(`${BASE_URL}/submit_query/?group_id=${groupID}`, query)
            .then((res) => {
                if (res.status === 201) {
                    setIsGenerating(false);
                    navigate(`/response`, {
                        state: {
                            id: res?.data?.conversation_id,
                            showres: true,
                            newQuery: true,
                        },
                    });
                    dispatch(queryResponseReduc({ queryResponse: res?.data }));
                }
            })
            .catch(() => {
                setIsGenerating(false);
            });
    };
}


// Estimate Cost Api

export function estimateCostApi(query, setCost) {
    console.log(query, "queryqueryqueryqueryquery");

    return async (dispatch) => {
        try {
            const res = await api.get(`${BASE_URL}/estimate_cost/?query=${query}`);

            console.log("Estimate cost response:", res.data);

            dispatch(getEstimateCostReduc({ getEstimateCost: res.data }));

            if (setCost) {
                setCost(res.data?.estimated_cost_usd || 0);
            }
        } catch (err) {
            console.error(
                "Estimate cost API failed:",
                err?.response?.data || err.message
            );
        }
    };
}

export function saveQueryApi(data) {
    return async () => {
        await api
            .post(`${BASE_URL}/queries/`, data)
            .catch((err) => console.log(err, "error"));
    };
}

// Change password API
export function ChangePasswordApi(data, navigate) {
    return async () => {
        await api
            .post(`${BASE_URL}/change_password/`, data)
            .then((res) => {
                if (res.status === 200) {
                    SuccessToast(res?.data?.message);
                    setTimeout(() => {
                        sessionStorage.clear();
                        navigate("/");
                    }, 1000);
                }
            })
            .catch((err) => {
                FailureToast(err?.response?.data?.error);
            });
    };
}

// Delete a conversation by ID
export function deleteConversationReduc(id) {
    const groupId = sessionStorage.getItem("currentGrp");
    return async (dispatch) => {
        await api
            .delete(`${BASE_URL}/conversations/${id}/`)
            .then((res) => {
                if (res.status === 200 || res.status === 204) {
                    SuccessToast("Deleted Successfully");
                    dispatch(fetchAllConversationSearchAPI());
                } else {
                    FailureToast("Deletion Failed");
                }
            })
            .catch((err) => {
                FailureToast(err?.response?.data?.error);
            });
    };
}

// Fetch class data for modification
export function getModifyClassdataApi() {
    return async (dispatch) => {
        await dispatch(classDataReduc({ classDataLoading: true }));
        await api
            .get(`${BASE_URL}/modify_categories/`)
            .then((res) => {
                if (res.status === 200) {
                    dispatch(classDataReduc({ classDataLoading: false, modifyClassData: res?.data }));
                }
            })
            .catch(() => {
                dispatch(classDataReduc({ classDataLoading: false }));
            });
    };
}


// Fetch all conversations with filters and search
export function fetchAllConversationSearchAPI(page, subject, startDate, endDate, filter, userId) {
    const body = {
        start_date: startDate ?? null,
        end_date: endDate ?? null,
        subject: subject ?? "",
        users: userId ?? null,
    };
    const groupID = sessionStorage.getItem("currentGrp");

    return async (dispatch) => {
        await dispatch(allConversationReduc({ convoLoading: true }));
        await api
            .post(
                filter
                    ? `${BASE_URL}/dashboard/conversations/`
                    : `${BASE_URL}/dashboard/conversations/?page=${page + 1}&page_size=10&group_id=${groupID}`,
                body
            )
            .then((res) => {
                if (res.status === 200) {
                    dispatch(allConversationReduc({ data: res.data, convoLoading: false }));
                    dispatch(fetchFilterUserAPI(groupID));
                }
            })
            .catch(() => {
                dispatch(allConversationReduc({ convoLoading: false }));
            });
    };
}

// Fetch filterable group list and default selections
export function fetchFilterGroupAPI(setSelectedDateLabel) {
    return async (dispatch) => {
        await api
            .get(`${BASE_URL}/list-groups`)
            .then((res) => {
                if (res.status === 200) {
                    sessionStorage.setItem("currentGrp", res?.data?.[0]?.id);
                    sessionStorage.setItem("userType", res?.data?.[0]?.user_type);
                    dispatch(fetchAllConversationSearchAPI(0));
                    dispatch(fetchFilterUserAPI(res?.data?.[0]?.id));
                    dispatch(filterReduc({ data: res?.data }));
                }
            });
    };
}

// Fetch users for a selected group
export function fetchFilterUserAPI(userId) {
    return async (dispatch) => {
        await api
            .get(`${BASE_URL}/list-users/?group_id=${userId}`)
            .then((res) => {
                if (res.status === 200) {
                    dispatch(filterUserReduc({ userdata: res.data }));
                }
            })
            .catch(() => {
                dispatch(filterUserReduc({ convoLoading: false }));
            });
    };
}



// Edit profile picture
export function editProfileAPI(profile) {
    const body = { profile_pic: profile };
    return async (dispatch) => {
        await api
            .put(`${BASE_URL}/profile/`, body)
            .then((res) => {
                if (res.status === 200) {
                    SuccessToast("Profile updated successfully");
                    dispatch(profileDataReduc({ userdata: res?.data?.data?.profile_pic }));
                }
            });
    };
}


export function userDetailsApi() {
    return async (dispatch) => {
        try {
            const res = await api.get(`${BASE_URL}/user-details/`);
            if (res.status === 200) {
                sessionStorage.setItem("createdBy", res?.data?.id);
                sessionStorage.setItem("full_name", res?.data?.full_name);
                sessionStorage.setItem("IsAdmin", res?.data?.isAdmin);
                dispatch(profileDataReduc({ userdata: res?.data }));
                dispatch(profileDataReduc({ userdata: res.data }));
                dispatch(setSessionReady(true));
                return res.data; // Return data here
            }
        } catch (e) {
            console.log(e?.response?.data?.detail, "--errormessagefrom");
            dispatch(setSessionReady(true));
            return null;
        }
    };
}
